import React, { useState } from 'react';
import { Info, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const DisclaimerBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div data-testid="medical-disclaimer-banner" className="bg-[#0B0D0C] border-b border-white/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-3 py-3">
          <div className="w-5 h-5 rounded-full bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
            <Info className="w-3 h-3 text-emerald-400" />
          </div>
          <p className="text-xs text-neutral-400 flex-1 leading-relaxed">
            <span className="text-neutral-200 font-medium">Медицински отказ:&nbsp;</span>
            Информацията е с образователна цел и не замества медицинска консултация.
            <Link
              to="/disclaimer"
              data-testid="medical-disclaimer-link"
              className="ml-1.5 text-emerald-400 hover:text-emerald-300 underline underline-offset-2 transition-colors duration-150"
            >
              Научи повече
            </Link>
          </p>
          <button
            onClick={() => setDismissed(true)}
            aria-label="Затвори"
            className="w-5 h-5 rounded-full flex items-center justify-center text-neutral-600 hover:text-neutral-300 hover:bg-white/5 transition-colors duration-150 flex-shrink-0"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
};
